import { Fragment, useCallback } from "react";
import { useMultistep } from "../../../hooks/useMultipleStep";
import EstablishmentGeneralInfosForm from "../../../components/ClientSpace/Signup/EstablishmentForms/EstablishmentGeneralInfosForm";
import EstablishmentCategoryForm from "../../../components/ClientSpace/Signup/EstablishmentForms/EstablishmentCategoryForm";
import EstablishmentAddressForm from "../../../components/ClientSpace/Signup/EstablishmentForms/EstablishmentAddress/EstablishementAddressForm";
import EstablishmentManagerForm from "../../../components/ClientSpace/Signup/EstablishmentForms/EstablishmentContacts/EstablishmentManagerForm";
import EstablishmentProjectManagerForm from "../../../components/ClientSpace/Signup/EstablishmentForms/EstablishmentContacts/EstablishmentProjectManagerForm";
import EstablishmentBillingManagerForm from "../../../components/ClientSpace/Signup/EstablishmentForms/EstablishmentContacts/EstablishmentBillingManagerForm";
import PasswordForm from "../../../components/ClientSpace/Signup/User/PasswordForm";
import UserContactForm from "../../../components/ClientSpace/Signup/User/UserContactForm";
import { Box } from "@mui/material";
import SignupHeader from "../../../components/ClientSpace/Signup/SignupHeader/SignupHeader";
import {
    sessionStorageKey,
    stepsNumber,
    contactsStorageKey,
} from "../../../consts";
import { useNavigate } from "react-router-dom";
import { ContactProfilsEnum, Session } from "../../../types";
import { useLocalStorage } from "../../../hooks";
import { RoutesEnum } from "../../../router/routes";

export default function Signup() {
    const navigate = useNavigate();
    function onPropagateFunc(step: number) {
        if (step === -1) back();
        else goTo(step);
    }

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        [contactsStorageKey]: { profils: contactProfils },
    } = session;

    const managerProfilId = (
        contactProfils.find((cp) => cp.code === ContactProfilsEnum.MANAGER) ||
        {}
    ).id;
    const projectManagerProfilId = (
        contactProfils.find(
            (cp) => cp.code === ContactProfilsEnum.PROJECT_MANAGER
        ) || {}
    ).id;

    const billingManagerProfilId = (
        contactProfils.find(
            (cp) => cp.code === ContactProfilsEnum.BILLING_MANAGER
        ) || {}
    ).id;

    const canSignup =
        managerProfilId && billingManagerProfilId && projectManagerProfilId;

    const { step, back, goTo, stepNumber } = useMultistep(
        !canSignup
            ? []
            : [
                  <EstablishmentGeneralInfosForm
                      goto={onPropagateFunc}
                      nextStep={1}
                  />,
                  <EstablishmentCategoryForm
                      goto={onPropagateFunc}
                      nextStep={2}
                  />,
                  <UserContactForm goto={onPropagateFunc} nextStep={3} />,
                  <EstablishmentAddressForm
                      goto={onPropagateFunc}
                      nextStep={4}
                  />,
                  <EstablishmentManagerForm
                      goto={onPropagateFunc}
                      nextStep={5}
                      profilId={managerProfilId + ""}
                  />,
                  <EstablishmentProjectManagerForm
                      goto={onPropagateFunc}
                      nextStep={6}
                      profilId={projectManagerProfilId + ""}
                  />,
                  <EstablishmentBillingManagerForm
                      goto={onPropagateFunc}
                      nextStep={7}
                      profilId={billingManagerProfilId + ""}
                  />,
                  <PasswordForm goto={onPropagateFunc} stepNum={stepsNumber} />,
              ]
    );

    const handleBack = useCallback(() => {
        if (stepNumber === 1) {
            navigate("/" + RoutesEnum.login);
        }
        back();
    }, [stepNumber, back, navigate]);

    return (
        <Fragment>
            <SignupHeader
                step={stepNumber}
                back={handleBack}
                stepsNumber={stepsNumber}
            />
            <Box
                display={"flex"}
                sx={{
                    flexShrink: 0,
                    borderRadius: "2rem 2rem 0rem 0rem",
                    background: "#E5EEF5",
                    minHeight: "78vh",
                    justifyContent: "center",
                    alignItems: "flex-start",
                }}
            >
                <Box
                    display="flex"
                    sx={{
                        flexDirection: "column",
                        gap: "2.5rem",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "3.25rem",
                        marginLeft: "5.2rem",
                        marginRight: "1.5rem",
                        "@media (max-width:1024px)": {
                            marginLeft: "1.5rem",
                        },
                    }}
                >
                    {step}
                </Box>
            </Box>
        </Fragment>
    );
}
